import root from './_root.js';

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

export default Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/_Uint8Array.js
// module id = 365
// module chunks = 0